import { Box } from "@mui/material";
import { useState } from "react";
import LoanFormPopupV2 from "../../Drawer/LoanFormPopupV2";
import FAQ from "../../SDK/FAQ/faq";
import TurnoPromiseComponent from "../../SDK/FAQ/turnoPromiseComponent";
import { vehicleFAQs } from "../../constants/brandFaqs";
import { keySpecificationsInfo } from "../../constants/vehicleKeySpec";
import { vehiclePromiseList } from "../../constants/vehiclesPromises";
import { imagesWEBP } from "../../constants/webpImages";
import { MemoizedFooter } from "../../layouts/footer";
import { MemoizedHeader } from "../../layouts/header";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import { SecondaryHeader } from "../../components/common";
import PricingSelectCityModal from "../../components/PricingPage/PricingSelectCityModal";
import PricingPopularCities from "../../components/PricingPage/PricingPopularCities";
import BookVehicleDrawer from "../Home/Drawer/bookVehicleDrawer";
import MemoizedKeySpecifications from "../Home/VehiclesV2/KeySpecifications";
import ProductTopBanner from "../Home/VehiclesV2/ProductTopBanner";
import MemoizedVehicleFeatures from "../Home/VehiclesV2/VehicleFeatures";
import VehicleSpecificUseSwiper from "../Home/VehiclesV2/VehicleSpecificUses";
import WebShare from "../Lead Capture/WebShare.jsx/WebShare";
import HeaderDesc from "../Vehicles/Banner/HeaderDesc";
import MemoizedBrandDealerNear from "../Vehicles/BrandDealerNear";
import { MemoizedLeadCaptureV2 } from "../../pages/LeadCapture/LeadCaptureV2";
import { passengerVehiclePromiseList } from "../../constants/promiseData";
import MemoizedSearchHeader from "../Vehicles/searchHeader.jsx";

const ElectricPassengerVehicleLandingPage = ({
  brand = "",
  vehicleModel = "",
  location = "",
  vehicleDataLocal = [],
  vehicleName = "",
  KEY_SPECIFICATION_HEADER = "",
  HIGHLIGHTS_HEADER = "",
  SUB_TEXT = "",
  BENEFITS_HEADER = "",
  VEHICLE_FEATURE_HEADER = "",
  BRAND_DEALER_HEADER = "",
  BRAND_DEALER_DESCRIPITION = "",
  FAQ_HEADER_TEXT = "",
  noentryData = [],
  H1_HEADING = "",
  BREADCRUMB_ITEMS = [],
  secondaryHeaderItems = [],
  priceCities = [],
  pricePathPrefix,
  showPricingPopularCities = true,
}) => {
  const [activeSectionId, setActiveSectionId] = useState("section-header");
  const [priceCityModalOpen, setPriceCityModalOpen] = useState(false);

  const showSecondaryHeader = Array.isArray(secondaryHeaderItems) && secondaryHeaderItems.length > 0;
  const handlePriceCitySelect = (citySlug) => {
    setPriceCityModalOpen(false);
    const path = pricePathPrefix
      ? `/electric-commercial-vehicles/${pricePathPrefix}/price/${citySlug}`
      : brand && vehicleModel
        ? `/electric-commercial-vehicles/${brand}/${vehicleModel}/price/${citySlug}`
        : null;
    if (path) window.location.href = path;
  };
  const itemsWithPriceModal = showSecondaryHeader
    ? secondaryHeaderItems.map((item) =>
        item.sectionId === "section-price" && priceCities.length > 0
          ? { ...item, onClick: () => setPriceCityModalOpen(true) }
          : item
      )
    : [];

  return (
    <>
      <body>
        <Box>
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <MemoizedHeader scrollWithPage={showSecondaryHeader} />
          </Box>
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <MemoizedSearchHeader isProductPage={true} />
          </Box>
          {showSecondaryHeader && (
            <>
              <SecondaryHeader
                items={itemsWithPriceModal}
                activeSectionId={activeSectionId}
                onActiveSectionChange={setActiveSectionId}
                scrollOffsetTop={70}
              />
              {priceCities.length > 0 && (
                <PricingSelectCityModal
                  isOpen={priceCityModalOpen}
                  onClose={() => setPriceCityModalOpen(false)}
                  currentCitySlug={null}
                  availableCities={priceCities}
                  onSelectCity={handlePriceCitySelect}
                />
              )}
            </>
          )}
          {/* Main component */}
          {/* <Box
            id={showSecondaryHeader ? "section-header" : undefined}
            sx={{ display: { xs: "none", md: "block" }, background: "#F3F3F4" }}
          >
            <ProductTopBanner
              location={location}
              vehicle_name={H1_HEADING}
            />
          </Box> */}
          <Box
            sx={{
              position: "relative",
              width: "100%",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "0",
                left: "0",
                zIndex: "120",
                display: { xs: "block", md: "none" },
                width: "100%",
              }}
            >
              <WebShare vehicleData={vehicleDataLocal[0]} />
              <BookVehicleDrawer />
            </Box>
          </Box>

          <Box id={showSecondaryHeader ? "section-price" : undefined}>
            <MemoizedLeadCaptureV2 vehicleDataLocal={vehicleDataLocal} />
          </Box>
          <Box id={showSecondaryHeader ? "section-specification" : undefined}>
            <MemoizedKeySpecifications
              keySpecifications={keySpecificationsInfo?.[vehicleName]}
              headerInfo={KEY_SPECIFICATION_HEADER}
            />
          </Box>
          <Box id={showSecondaryHeader ? "section-summary" : undefined}>
            <HeaderDesc
              HeadingTag="h2"
              heading={HIGHLIGHTS_HEADER}
              subText={SUB_TEXT}
            />
          </Box>

          {
            noentryData.length > 0 && (
              <VehicleSpecificUseSwiper
              slidePerView={4}
              data={noentryData}
              headerInfo={BENEFITS_HEADER}
            />
            )
          }

          <MemoizedVehicleFeatures
            promisesData={vehiclePromiseList?.[vehicleName]}
            headerInfo={VEHICLE_FEATURE_HEADER}
            hideFeaturesHeader={true}
          />

          <MemoizedBrandDealerNear
            BannerDealerData={{
              headerInfo: BRAND_DEALER_HEADER,
              description: BRAND_DEALER_DESCRIPITION,
              desktopImg: imagesWEBP?.locationBanner,
              mobileImg: imagesWEBP?.multibrandstore,
            }}
          />

          {showSecondaryHeader && showPricingPopularCities && (brand || pricePathPrefix) && (
            <PricingPopularCities
              vehicleBrand={brand}
              vehicleName={vehicleDataLocal?.[0]?.vehicle_name || vehicleDataLocal?.[0]?.name || ""}
              brand={pricePathPrefix ? pricePathPrefix.split("/")[0] || brand : brand}
              model={pricePathPrefix ? pricePathPrefix.split("/").slice(1).join("/") || vehicleModel : vehicleModel}
            />
          )}

          <Box
            sx={{
              width: "100vw",
              alignItems: "center",
              flexDirection: "column",
              paddingLeft: { xs: "10px", sm: "8%", md: "8%", lg: "8%" },
              paddingRight: { xs: "10px", sm: "8%", md: "8%", lg: "8%" },
              marginTop: "48px",
              paddingTop: "12px",
            }}
          >
            <TurnoPromiseComponent promiseData={passengerVehiclePromiseList} />

            <Box
              sx={{
                padding: { xs: "10px", sm: "10px", md: "20px", lg: "20px" },
              }}
            >
              <FAQ
                faqList={vehicleFAQs?.[vehicleName]}
                showItems={5}
                headText={FAQ_HEADER_TEXT}
              />
            </Box>

            <LoanFormPopupV2 />
          </Box>

          {Array.isArray(BREADCRUMB_ITEMS) && BREADCRUMB_ITEMS.length > 0 && (
            <Box
              sx={{
                width: { xs: "100%", md: "84%" },
                margin: "20px auto",
                padding: { xs: "0 12px", md: "0" },
              }}
            >
              <Breadcrumbs items={BREADCRUMB_ITEMS} />
            </Box>
          )}

          <MemoizedFooter />
        </Box>
      </body>
    </>
  );
};

export default ElectricPassengerVehicleLandingPage;
